import Entity from 'utilities/entity';
import Spark from './spark';
import People from './people';
import Dream from './dream';

class Skill extends Entity {
  sparks() {
    return this.hasMany(Spark);
  }

  // people() {
  //   return this.hasMany(People);
  // }

  // dreams() {
  //   return this.hasMany(Dream);
  // }
}

export default new Skill();
